import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)({
	width: '100vw',
	paddingLeft: '20px',
	paddingRight: '20px',
});
